/**
 * Layout primitive for the per-field "help gutter" (CZNA-388).
 *
 * Historically the `<HelpTooltip>` "?" was embedded inside a control's
 * `label` (or trailing a `<label>` before its `<input>`), so its horizontal
 * position drifted with the label's text length — the "?" for a short label
 * sat much further left than the "?" for a long one, giving the settings
 * form a ragged, inconsistent look.
 *
 * `<FieldHelpRow>` fixes that by rendering a flex row with the control on
 * the left and the help icon pinned to the right edge, so every row's "?"
 * lines up in a single vertical column (the "gutter") regardless of label
 * length. It does not touch the control itself — Checkbox/Select/TextField/
 * plain `<label>+<input>` stay exactly as they were, just relocated out of
 * the label content and into this wrapper.
 *
 * Deliberately dumb/presentational: no state, no logic, just layout. See
 * `HelpTooltip.tsx` for the i18n / testid conventions of the icon itself.
 */
import React from 'react';
import HelpTooltip from './HelpTooltip';
var FieldHelpRow = function (_a) {
    var helpMessageId = _a.helpMessageId, helpTestKey = _a.helpTestKey, helpIdPrefix = _a.helpIdPrefix, children = _a.children;
    return (React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.5rem' } },
        React.createElement("div", { style: { minWidth: 0, flex: 1 } }, children),
        React.createElement(HelpTooltip, { messageId: helpMessageId, testKey: helpTestKey, idPrefix: helpIdPrefix })));
};
export default FieldHelpRow;
